// ActionIcon creates a rounded shape (usually a circle) that
// performs some action (usually social sharing) when clicked.
// The size and color of an ActionIcon is set by its parent
// container, via `font-size` and `color` respectively. By default
// we assume the svg icon in ActionIcon is square.
// If the ActionIcon has the isBranded prop set to `true`
// any inherited colors will be overridden by a brand-appropriate
// color.

import css from 'styled-jsx/css';
import { sharedPalette, warmGrays } from 'styles/colors/constants';
import { MQ_LARGE } from 'constants/mq';

export default css`
  .ActionIcon {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 1.5em;
    padding: 0.5em;
    background-color: currentColor;
    color: inherit;
  }

  .ActionIcon__content {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    color: #fff;
    line-height: 1em;
  }

  .ActionIcon__label {
    padding: 0 0.25em;
    font-size: calc(
      (
        (1em / var(--fontMultiplier) / var(--fontMultiplier)) /
          var(--fontMultiplier)
      )
    );
    letter-spacing: 0.02em;
    text-transform: uppercase;
  }

  .ActionIcon--disabled {
    background-color: ${warmGrays[4]};
    cursor: default;
  }

  .ActionIcon--branded.ActionIcon--comment,
  .ActionIcon--branded.ActionIcon--saveStory {
    color: ${sharedPalette.watermelon};
  }

  .ActionIcon--branded.ActionIcon--email {
    color: ${sharedPalette.email};
  }

  .ActionIcon--branded.ActionIcon--external {
    color: ${sharedPalette.watermelon};
  }

  .ActionIcon--branded.ActionIcon--facebook {
    color: ${sharedPalette.facebook};
  }

  .ActionIcon--branded.ActionIcon--flipboard {
    color: ${sharedPalette.flipboard};
  }

  .ActionIcon--branded.ActionIcon--instagram {
    color: ${sharedPalette.instagram};
  }

  .ActionIcon--branded.ActionIcon--pinterest {
    color: ${sharedPalette.pinterest};
  }

  .ActionIcon--branded.ActionIcon--twitter {
    color: ${sharedPalette.twitter};
  }

  .ActionIcon--branded.ActionIcon--youtube {
    color: ${sharedPalette.youtube};
  }

  .ActionIcon--branded.ActionIcon--link {
    color: #0f4c82;
  }

  .ActionIcon--branded.ActionIcon--siteBranded {
    color: ${sharedPalette.watermelon};
  }

  .ActionIcon--knockout {
    border: 1px solid currentColor;
    background-color: transparent;
  }

  .ActionIcon--knockout .ActionIcon__content {
    color: inherit;
  }

  .ActionIcon--fitted {
    height: 100%;
    padding: 0;
    width: 100%;
  }

  @media ${MQ_LARGE} {
    .ActionIcon__label {
      padding: 0 0.25em;
      font-size: calc(1em / var(--fontMultiplier));
      letter-spacing: 0.02em;
      text-transform: uppercase;
    }
  }
`;
